const toastErrorCodesHidden = [
  'PCS0001',
  'PCS0006',
  'PCS0008',
  'PCS0009',
  'PCS0010',
  'PCS0011',
  'PCS0012',
  'PCS0014',
  'PCS0019',
  'PCS0018',
  'PCS0022',
  'PCS0023',
  'PCS0034',
  'PCS0036',
  'PCS0039',
  'PCS0044',
  'PCS0045',
  'PCS0046',
  'PCS0047',
  'PCS0052',
  'PCS0053',
  'PCS0054',
  'PCS0055',
  'PCS0056',
  'PCS0059',
  'PCS0060',
  'PCS0061'
];

export {
  toastErrorCodesHidden
};

